// extracted by mini-css-extract-plugin
module.exports = {"small":"Icons_small__T0noL","normal":"Icons_normal__1V9Zt","large":"Icons_large__Nr3kr","custom":"Icons_custom__bRlqw","svg":"Icons_svg__3dV5-"};